export default __webpack_public_path__ + "static/media/tecnico.ce016b87.svg";